import type {ReactElement, ReactNode} from 'react';
import useQueryWithAuth from '@hooks/useQueryWithAuth';
import {me} from '@api/user';
import RequestError from '@errors/RequestError';
import LoadingDialog from '@components/LoadingDialog/LoadingDialog';
import {Trans} from '@lingui/macro';
import PrivateRoute from '@routes/PrivateRoute';

interface Props {
    children: ReactNode;
}

export default function AdminRoute(props: Props): ReactElement<Props> {
    const query = useQueryWithAuth({
        queryKey: ['me'],
        queryFn: me,
        refetchOnWindowFocus: true,
    });

    if (
        query.isError &&
        !(query.error instanceof RequestError && query.error.isAuthorizationError())
    ) {
        throw query.error;
    }

    if (query.isLoading) {
        return <LoadingDialog isOpen={query.isLoading} />;
    }

    if (query.data?.data.role !== 'admin') {
        return (
            <div>
                <h1>
                    <Trans>You cannot gain access to this part of the platform</Trans>
                </h1>
            </div>
        );
    }

    return <PrivateRoute>{props.children}</PrivateRoute>;
}
